import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c057469"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collections" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Alle Sammlungen", -1))
const _hoisted_3 = { class: "panels" }

import CollectionPanel from '../components/CollectionPanel.vue';
import { computed } from '@vue/reactivity';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectionsListView',
  setup(__props) {

const store = useStore()

const collections = computed(() => store.getters.getCollections)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collections), (item) => {
        return (_openBlock(), _createBlock(CollectionPanel, {
          key: item.title,
          collection: item
        }, null, 8, ["collection"]))
      }), 128))
    ])
  ]))
}
}

})